module.exports = __webpack_public_path__ + "media/images/calendar_sim_golf-1534fb38.svg";